import { TranslateService } from '@ngx-translate/core';
import { UserService } from './../../base-services/user.service';
import { TabsContainerService } from './../../base-classes/containers/services/tabs-container.service';
import { BaseDefaultListComponent } from './base-default-list.component';
import { BaseContainerService } from './../../base-classes/containers/services/base-container-service';
import { BaseDataService } from './../../base-services/base-data.service';
import { ActivatedRoute } from '@angular/router';
import { BaseEntity } from './../../base-models/base-entity';
import { BaseListComponent } from './../../base-classes/base-list-component';
import { Component, OnInit, Output, EventEmitter, ComponentFactoryResolver, ViewChild, TemplateRef, Input } from '@angular/core';

import { ModalService } from '../../base-services/modal.service';
import { DefaultTableComponent } from '../default-table/default-table.component';
import { UserRightsService } from '../../base-services/user-rights.service';
import { CryptoService } from '../../base-services/crypto.service';
import { NotificationService } from '../../base-services/notification-service';

@Component({
  selector: 'yt-fw-default-list-tabs',
  templateUrl: './default-list-tabs.component.html'
  //styleUrls: ['./default-list.component.css']
})
export class DefaultListTabsComponent<T extends BaseEntity> extends BaseDefaultListComponent<T> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    protected tabsContainerService: TabsContainerService<T>,
    protected userService: UserService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected modalService: ModalService,
    protected componentFactoryResolver: ComponentFactoryResolver,
    protected userRightsService: UserRightsService
  ) {
    super(activatedRoute, baseDataService, tabsContainerService, userService, toastrService, translateService, modalService, componentFactoryResolver);
  }

@ViewChild('detailTable', {static: false}) detailTable : DefaultTableComponent;
@ViewChild('detailTable1', {static: false}) detailTable1 : DefaultTableComponent;
@ViewChild('defaultTable', {static: false}) defaultTable : DefaultTableComponent;
@Input() extraButtonsTemplate: TemplateRef<any>;

ngOnInit() {
  super.ngOnInit();

  if (this.modelData.MainList.DetailList.length >= 2) {
    const model = this.modelData.MainList.DetailList[1].UserRightsModelName.toLowerCase() || this.modelData.MainList.DetailList[1].ModelName.toLowerCase();
    this.hasDetail1Access = this.userRightsService.GetUserRightValue(model, 'see_secondDetailList');
    this.modelData.MainList.DetailList[1].ShowOnFirstPage = this.hasDetail1Access;
  }

  if (
    this.modelData.MainList.DetailList.length === 2 &&
    this.modelData.MainList.DetailList[0].ShowOnFirstPage &&
    this.modelData.MainList.DetailList[1].ShowOnFirstPage
  ) {
    if (this.DetailTableConfig) {
      this.DetailTableConfig.Height = '50w';
      this.DetailTableConfig.IsModal = true;
    }
    if (this.DetailTableConfig1) {
      this.DetailTableConfig1.IsModal = true;
    }
  }

    
    // setTimeout(() => {
    //   if (
    //     this.defaultTable &&
    //     this.modelData.MainList.DetailList &&
    //     this.modelData.MainList.DetailList.length > 0
    //   ) {
    //     this.modelData.MainList.DetailList[0].ShowOnFirstPage =
    //       this.defaultTable.detailTableVisible;
    //   }
    // }, 0);

    this.initDetailVisibilityFromStorage(); 
  }

ngAfterViewInit() {
  super.ngAfterViewInit();

  let stored: any = null;
  try {
    const raw = localStorage.getItem(this.getStorageKey());
    stored = raw ? JSON.parse(raw) : null;
  } catch {}

  const hasDetailInStorage = stored && typeof stored.detailVisible === 'boolean';

  Promise.resolve().then(() => {
    if (!hasDetailInStorage && this.defaultTable) {
      const visibleFromRoute = !!this.modelData.MainList.DetailList[0] &&
        this.modelData.MainList.DetailList[0].ShowOnFirstPage === true;

      this.defaultTable.detailTableVisible = visibleFromRoute;

      setTimeout(() => {
        if (this.defaultTable) {
          this.defaultTable.setColumnsRatio(this.defaultTable.currentRatio, false);
        }
      }, 0);
    }
  });
}



  ngOnDestroy() {
    super.ngOnDestroy();
    if (this.detailTable) {
        this.detailTable = null;
    }
  }

  EditItem(event){
    super.EditItem(event);
    if(this.defaultTable)
      this.defaultTable.filter="";
    if(this.detailTable)
      this.detailTable.filter="";
    if(this.detailTable1)
      this.detailTable1.filter="";
  }


public ClearSearch() {
  if (this.defaultTable.ClearSearchBox) {
    this.defaultTable.ClearSearchBox(); 
  }
}

private initDetailVisibilityFromStorage(): void {
  var key = this.getStorageKey();

  var stored: any = null;
  try {
    var raw = localStorage.getItem(key);
    stored = raw ? JSON.parse(raw) : null;
  } catch (e) {
    stored = null;
  }

  var visible: any = null; 

  if (stored && typeof stored.detailVisible === 'boolean') {
    visible = stored.detailVisible;
  }

  if (visible === null) {
    var showFromRoute = false;
    if (this.modelData &&
        this.modelData.MainList &&
        this.modelData.MainList.DetailList &&
        this.modelData.MainList.DetailList.length > 0 &&
        typeof this.modelData.MainList.DetailList[0].ShowOnFirstPage === 'boolean') {
      showFromRoute = this.modelData.MainList.DetailList[0].ShowOnFirstPage === true;
    }
    visible = showFromRoute;
  }

  if (this.modelData &&
      this.modelData.MainList &&
      this.modelData.MainList.DetailList &&
      this.modelData.MainList.DetailList.length > 0) {
    this.modelData.MainList.DetailList[0].ShowOnFirstPage = visible;
  }
}

private getStorageKey(): string {
  var decrypted: any = null;
  try { decrypted = CryptoService.Decrypt(sessionStorage.getItem('sel-user')); } catch (e) { decrypted = null; }
  var userId = '0';
  if (decrypted && decrypted.UserID !== null && decrypted.UserID !== undefined) userId = String(decrypted.UserID);
  var breadcrumb = (this.modelData && this.modelData.BreadcrumbLabel) ? this.modelData.BreadcrumbLabel : '';
  return 'defaultTable_' + userId + '_' + breadcrumb;
}

}
